import { LaborCalendarBoard } from './LaborCalendarBoard';
import { LABOR_CALENDAR_VIEWS } from './services/laborScheduleService';

const LaborCalendario = () => (
  <LaborCalendarBoard
    allowedViews={[LABOR_CALENDAR_VIEWS.FACTORY, LABOR_CALENDAR_VIEWS.PATTERN]}
    title="Calendario laboral"
    description="Horarios por fábrica o patrón. La fábrica del header filtra empleados y calendario de planta."
  />
);

export default LaborCalendario;
